<template>
  <div>
    <h1 class="onboarding__title mb-15">
      {{ $t('onboarding.plans.title') }}
    </h1>

    <div class="onboarding__options">
      <v-btn-toggle class="onboarding__plans" v-model="plan">
        <v-row>
          <v-col cols="12" md="6">
            <v-btn
              value="SINGLE_PURCHASE"
              class="onboarding__plans-item"
              @click="setOnboardingSelectedPlan('SINGLE_PURCHASE')"
            >
              <v-row no-gutters align="center">
                <v-col cols="2">
                  <v-icon
                    :color="
                      plan === 'SINGLE_PURCHASE' ? 'primary' : 'grey lighten-2'
                    "
                    small
                  >
                    mdi-check
                  </v-icon>
                </v-col>
                <v-col cols="10">
                  <p class="onboarding__plans-title mb-0">
                    {{ $t('onboarding.plans.single.title') }}
                    <small class="onboarding__plans-description">
                      {{ $t('onboarding.plans.single.description') }}
                    </small>
                  </p>
                </v-col>
              </v-row>
            </v-btn>
          </v-col>
          <v-col cols="12" md="6">
            <v-btn
              class="onboarding__plans-item"
              value="RECURRING_PURCHASE_3"
              @click="setOnboardingSelectedPlan('RECURRING_PURCHASE_3')"
            >
              <v-row no-gutters align="center">
                <v-col cols="2">
                  <v-icon
                    :color="
                      plan === 'RECURRING_PURCHASE_3'
                        ? 'primary'
                        : 'grey lighten-2'
                    "
                    small
                  >
                    mdi-check
                  </v-icon>
                </v-col>
                <v-col cols="10">
                  <p class="onboarding__plans-title mb-0">
                    {{ $t('onboarding.plans.recurrent.title') }}
                    <small class="onboarding__plans-description">
                      {{ $t('onboarding.plans.recurrent.description') }}
                    </small>
                  </p>
                </v-col>
              </v-row>
            </v-btn>
          </v-col>
        </v-row>
      </v-btn-toggle>
    </div>

    <v-row class="mt-10" no-gutters>
      <v-col>
        <v-btn @click="setOnboardingStepsNavigation(2)" elevation="0" large>
          <v-icon left small> mdi-chevron-left </v-icon>
          {{ $t('onboarding.actions.previous') }}
        </v-btn>
      </v-col>
      <v-col class="text-right">
        <v-btn
          :disabled="!plan"
          :loading="isLoading"
          @click="handlePassPlan"
          color="primary"
          elevation="0"
          large
        >
          {{ $t('onboarding.actions.next') }}
          <v-icon right small> mdi-chevron-right </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { api } from '@/services'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'OnboardingStepsPlans',

  data() {
    return {
      plan: '',
    }
  },

  computed: {
    ...mapGetters([
      'isLoading',
      'onboardingSelectedServices',
      'onboardingSelectedPlan',
    ]),
  },

  methods: {
    ...mapMutations([
      'setIsLoading',
      'setOnboardingSelectedPlan',
      'setOnboardingStepsNavigation',
    ]),

    ...mapActions(['onboardingCreateContract']),

    handleSetNoSubscription() {
      this.setIsLoading(true)

      api
        .post('web/customerOnboarding/setNoSubscriptionStatus', {})
        .then(() => this.setOnboardingStepsNavigation(8))
        .catch(({ data }) => {
          data?.errors && data?.errors?.length >= 1
            ? this.showErrorMessage(data.errors[0].message)
            : this.showErrorMessage(data.message)
        })
        .finally(() => this.setIsLoading(false))
    },

    handlePassPlan() {
      const params = {
        contract_type: this.onboardingSelectedPlan,
        service_types: this.onboardingSelectedServices,
      }

      if (this.plan === 'SINGLE_PURCHASE') {
        this.onboardingCreateContract(params).then(() => {
          this.setOnboardingStepsNavigation(4)
        })
      } else {
        this.handleSetNoSubscription()
      }
    },
  },
}
</script>
